import leftPoint from '@/images/cscec3b/home/left-point.png'
import rightPoint from '@/images/cscec3b/home/right-point.png'
export default function HomeTitle({title}) {
  return <div className='content'>
    <img src={leftPoint} alt="" />
    <span style={{ color: '#020814', fontSize: '36px', fontWeight: 600, margin: '0 16px', lineHeight: '48px' }}>{title}</span>
    <img src={rightPoint} alt="" />
    <style jsx>{`
      .content {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 32px;
      }
    `}</style>
  </div>
}